import { IRootState } from 'app/shared/reducers';
import { isMobileDevice } from 'app/shared/util/methode-util';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ViewName } from '../../../tools/constants';
import DesktopSearchContract from '../../desktop/desktop-search-contract/search-contract';
import MobileSearchContract from '../../mobile/mobile-search-contract/search-contract';

const SearchContract = props => {
  const {
    updateObject,
    searchContractByNumber,
    selectedContract,
    nextView,
    setIsSearch,
    verifTryMax,
  } = props;

  const configuration: any = useSelector<IRootState>(state => state.global.configuration);
  const [checked, setChecked] = useState(false);
  const [mailValue, setMailValue] = useState('');
  const [subNumber, setSubNumber] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [disabledSearchButton, setDisabledSearchButton] = useState(true);
  const dispatchor = useDispatch();
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const handleChange = value => {
    if (!value || !isNaN(value)) {
      setSubNumber(value);
    }
  };

  useEffect(() => {
    setDisabledSearchButton(!subNumber || subNumber?.toString()?.trim()?.length === 0 || isNaN(parseInt(subNumber, 10)));
  }, [subNumber])

  const chekedFunc = () => {
    updateObject(ViewName.SUBSCRIPTION_ACCOUNT_SEARCH, { notMineSubscription: !checked }, 'array');
    setChecked(!checked);
  };

  const redirect = () => {

    const modifiedSubNumber = subNumber.padStart(12, '0');
    verifTryMax(subNumber);
    searchContractByNumber(modifiedSubNumber);
    
  };

  const redirectFoundSubs = () => {
      updateObject(
        ViewName.SUBSCRIPTION_ACCOUNT_SEARCH,
        { foundSubscription: selectedContract, notMineSubscription: checked },
        'array'
      );
      setIsSearch(false);
      nextView(); 
  };

  useEffect(() => {
    if(selectedContract?.valid )
       redirectFoundSubs()
  }, [selectedContract])

  const params = {
    ...props,
    showModel,
    setShowModel,
    avatar,
    checked,
    chekedFunc,
    mailValue,
    setMailValue,
    dispatchor,
    redirectFoundSubs,
    subNumber,
    handleChange,
    redirect,
    disabledSearchButton
  }
  return (
    <>
      {isMobileDevice(configuration) ?
        <MobileSearchContract {...params} />
        :
        <DesktopSearchContract {...params} />
      }
    </>
  );
};

export default SearchContract;
